import Vue from 'vue'
import Vuex from 'vuex'
import marks from './modules/marks'
import classes from './modules/classes'
import teachers from './modules/teachers'
import subjects from './modules/subjects'
import questions from './modules/questions'
import exams from './modules/exams'
Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		marks,
		classes,
		teachers,
		subjects,
		questions,
		exams,
	}
})
